import { Routes } from '@angular/router';
import {
  SupervisorHomeRoute,
  SupervisorAuthorisationsRoute,
  DetailRoute,
  EAuthorizationManagmentViewRightsRoute,
  EAuthorizationOverviewAccessibilityRoute,
  EAuthorizationOverviewFaqRoute,
  EAuthorizationOverviewSupportRoute,
  EAuthorizationOverviewTermsOfUse,
} from '../../../core/src/lib/constants/routes.constant';
import { NotFoundPage } from '../../../core/src/lib/pages/not-found/not-found.page';
import { EmptyRoute, ErrorRoute, NotFoundRoute } from '../../../core/src/lib/constants/routes.constant';
import { authGuard } from '../../../core/src/lib/guards/auth.guard';
import { ErrorPageComponent } from '../../../core/src/lib/pages/error-page/error-page.component';
import { CorePage } from './pages/core/core.page';
import { MenuPageSupervisor } from './pages/core/menuPage/menu-page-supervisor/menu-page-supervisor.component';
import { AuthorisationsPageSupervisor } from './pages/core/authorisationsPage/authorisations-page-supervisor/authorisations-page-supervisor.component';
import { ScannedDocumentComponent } from './pages/core/scanned-document/scanned-document/scanned-document.component';
import { AuthorizationHistoryDetailsPage } from '../../../core/src/lib/modules/eAuthorization-managment/pages/authorization-history-details/authorization-history-details.page';
import { AttachmentListComponent } from './pages/core/attachment-list/attachment-list/attachment-list.component';
import { authDocImagesResolver } from '../../../core/src/lib/resolvers/supervisor.resolver';
import { AuthorisationRejectComponent } from './pages/core/authorisation-reject/authorisation-reject/authorisation-reject.component';
import { AccessibilityStatmentPage } from '../../../core/src/lib/modules/eAuthorization-overview/pages/accessibility-statment/accessibility-statment.page';
import { FAQPage } from '../../../core/src/lib/modules/eAuthorization-overview/pages/faq/faq.page';
import { SupportPage } from '../../../core/src/lib/modules/eAuthorization-overview/pages/support/support.page';
import { TermsOfUsePage } from '../../../core/src/lib/modules/eAuthorization-overview/pages/terms-of-use/terms-of-use.page';

export const routes: Routes = [
  {
    path: EmptyRoute,
    redirectTo: SupervisorHomeRoute,
    pathMatch: 'full',
  },
  { path: EAuthorizationOverviewFaqRoute, component: FAQPage },
  { path: EAuthorizationOverviewSupportRoute, component: SupportPage },
  { path: EAuthorizationOverviewTermsOfUse, component: TermsOfUsePage },
  { path: EAuthorizationOverviewAccessibilityRoute, component: AccessibilityStatmentPage },
  {
    path: EmptyRoute,
    component: CorePage,
    children: [
      {
        path: 'supervisor-home',
        loadChildren: () => import('./supervisor-home.routes').then((r) => r.supervisorHomeRoutes),
      },
    ],
  },
  {
    path: EmptyRoute,
    component: MenuPageSupervisor,
    children: [
      {
        path: 'menu-page-supervisor',
        loadChildren: () => import('./supervisor-home.routes').then((r) => r.supervisorMenuRoutes),
      },
    ],
  },
  {
    path: SupervisorAuthorisationsRoute,
    component: AuthorisationsPageSupervisor,
    children: [
      {
        path: 'authorisations-page-supervisor',
        loadChildren: () => import('./supervisor-home.routes').then((r) => r.supervisorAuthorisationRoutes),
      },
    ],
  },
  {
    path: 'scanned-document-supervisor/:id',

    loadChildren: () => import('./supervisor-home.routes').then((r) => r.supervisorDocumentRoutes),
  },
  {
    path: 'reject-authorization/:id',
    component: AuthorisationRejectComponent,
    // resolve: {
    //   attachements: authDocImagesResolver,
    // },
  },
  {
    path: 'attachment-list/:id',
    component: AttachmentListComponent,
    resolve: {
      attachements: authDocImagesResolver,
    },
  },

  {
    path: `authorization-history-details/:docId/:konNavigate`,
    component: AuthorizationHistoryDetailsPage,
  },
  {
    path: ErrorRoute,
    component: ErrorPageComponent,
  },
  {
    path: NotFoundRoute,
    component: NotFoundPage,
    
  },
];
